import { useCallback, useEffect, useState } from 'react';
import { Switch } from 'antd-mobile';
import type { GetConfig } from '@/apis/my';
import { fetchSetConfig, fetchGetConfig } from '@/apis/my';
import { useAppHomeTitle } from '@/hooks/useTitle';
import '../index.less';

const OptionsPrivacy = () => {
  useAppHomeTitle('隐私');
  const [switchChecked, setSwitchChecked] = useState(true);

  const getConfig = useCallback(() => {
    fetchGetConfig()
      .then((res) => {
        if (res) {
          const guessFlag = res.guessFlag;
          setSwitchChecked(guessFlag === 1 ? true : false);
        }
      })
      .catch((err) => {
        console.error('[OptionsPrivacy]-getConfig', err);
      });
  }, []);

  const updateUserConfig = async () => {
    const params: GetConfig = {
      guessFlag: Number(!switchChecked),
    };
    await fetchSetConfig(params);

    setSwitchChecked(!switchChecked);
  };

  const onItemClick = () => {
    updateUserConfig().catch((err) => {
      console.error('[OptionsPrivacy]-onItemClick', err);
    });
  };

  useEffect(() => {
    void getConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={'options-list'}>
      <div className={'options-item'} onClick={onItemClick}>
        <div className={'item-left'}>
          <div className={'item-title'}>个性化推荐</div>
          <div className={'item-tips'}>关闭后，菜单页不再进行餐品推荐</div>
        </div>
        <div className={'item-right'}>
          <Switch checked={switchChecked} />
        </div>
      </div>
    </div>
  );
};
export default OptionsPrivacy;
